'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promiseCache = require('./promiseCache');

var _promiseCache2 = _interopRequireDefault(_promiseCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('es6-promise').polyfill();
require('isomorphic-fetch');

var defaultHeaders = function defaultHeaders(token) {
	var authorization = token ? 'Bearer ' + token : null;
	var headers = {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'X-Sipgate-Client': 'app.sipgate.com'
	};

	if (authorization) {
		headers.Authorization = authorization;
	}

	return headers;
};

var extractBody = function extractBody(res) {
	return res.text();
};

var parseJSON = function parseJSON(text) {
	try {
		return JSON.parse(text);
	} catch (e) {
		return text;
	}
};

var get = function get(apiUrl, token, onPromiseResolved) {
	return function (path) {
		var url = apiUrl + path;

		if (_promiseCache2.default.get(url)) {
			return _promiseCache2.default.get(url);
		}

		var promise = fetch(url, {
			method: 'get',
			headers: defaultHeaders(token)
		}).then(onPromiseResolved).then(function (response) {
			_promiseCache2.default.bust(url);
			return response;
		}).then(extractBody).then(parseJSON);

		_promiseCache2.default.set(url, promise);

		return promise;
	};
};

var del = function del(apiUrl, token, onPromiseResolved) {
	return function (path) {
		return fetch(apiUrl + path, {
			method: 'delete',
			headers: defaultHeaders(token)
		}).then(onPromiseResolved).then(extractBody).then(parseJSON);
	};
};

var post = function post(apiUrl, token, onPromiseResolved) {
	return function (path) {
		var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		return fetch(apiUrl + path, {
			method: 'post',
			body: JSON.stringify(data),
			headers: defaultHeaders(token)
		}).then(onPromiseResolved).then(extractBody).then(parseJSON);
	};
};

var put = function put(apiUrl, token, onPromiseResolved) {
	return function (path) {
		var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		return fetch(apiUrl + path, {
			method: 'put',
			body: JSON.stringify(data),
			headers: defaultHeaders(token)
		}).then(onPromiseResolved).then(extractBody).then(parseJSON);
	};
};

exports.default = function (apiUrl) {
	var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	var onPromiseResolved = arguments[2];
	return {
		getUnauthenticated: get(apiUrl, null, function (result) {
			return result;
		}),
		get: get(apiUrl, token, onPromiseResolved),
		del: del(apiUrl, token, onPromiseResolved),
		post: post(apiUrl, token, onPromiseResolved),
		put: put(apiUrl, token, onPromiseResolved)
	};
};


//////////////////
// WEBPACK FOOTER
// ./~/sipgate-rest-api-client/dist/http.js
// module id = 833
// module chunks = 0